import React, { useEffect, useState } from "react"
import format from "date-fns/format";
import { addBusinessDays, addDays, isToday } from "date-fns";
import { ResumoAcordo } from "./components/resumo";
import { ContratoData } from './components/contratoData'
import { ClienteInfo } from "../cliente-info";
import { useModal } from "../../../../../hooks/ModalContext";
import { GenericModal } from "../../../../Modal";
import { useDividas } from "../../../../../context/DividasContext";
import { usePropostas } from "../../../../../context/PropostasContext";
// import { CanaisEnvio, } from './components/canais-envio'
import { CanaisEnvio } from './components/canais-envio/CanalEnvioTesteRefeito'
import { useBoleto } from "../../../../../context/BoletoContext";
import { useMutation } from "@tanstack/react-query";
import { apiModulo } from "../../../../../services/api";

interface Item {
  id: string;
  descricao: string;
  interno: string;
}


export const FormPropostas = () => {
  const { setModal, modalInfo, onClose } = useModal();
  const { devedorCadastro, devedor, selectedCredor } = useDividas()
  const { vencimentos, selectedProposta, canalEnvio, getDateVencimento, date, setFormaPagamnento, formaPagamento } = usePropostas()
  const { boleto } = useBoleto()

  function formatDate(date: string) {
    if (date) {
      const [dia, mes, ano] = date?.split('/')
      return `${mes}/${dia}/${ano}`
    }
    return ''
  }
  const [datasVencimento, setDatasVencimento] = useState<string[]>([])

  const formasPagamentos = useMutation({
    mutationFn: () =>
      apiModulo.post('/options', {
        codcredor: selectedCredor.credor_crm,
        url: selectedCredor.url_ws,
        legenda: 'FORMA_PAGAMENTO',
        app: 'ACIONA_WEB',
      }),
  });

  useEffect(() => {
    formasPagamentos.mutateAsync();
  }, []);

  useEffect(() => {
    if (vencimentos.datamaxvencimento) {
      const proximoDia = (date: Date) => {
        if (isToday(date)) {
          return addBusinessDays(date, 1);
        }
        return addDays(date, 1);
      }
      const arrayDatas: string[] = [];
      let dataAtual = new Date();

      while (dataAtual <= new Date(formatDate(vencimentos.datamaxvencimento))) {
        const dataFormatada = format(dataAtual, 'dd/MM/yyyy');
        if (!isToday(dataAtual)) {
          arrayDatas.push(dataFormatada);
        }
        dataAtual = proximoDia(dataAtual);
      }
      setDatasVencimento([...arrayDatas, vencimentos?.datamaxvencimento]);
      getDateVencimento(vencimentos?.datamaxvencimento)
    }
  }, [vencimentos?.datamaxvencimento])

  function goToOpeningAccordion(id: string) {
    if (selectedProposta?.id && canalEnvio.destinorecebimento !== '' && canalEnvio.canalrecebimento !== '') {
      if (canalEnvio.canalrecebimento === 'email;sms') {
        const [email, sms] = canalEnvio.destinorecebimento.split(';')
        if (email === '' || sms === '') {
          setModal('Selecione uma proposta e canal de envio primeiro', 'Erro', false, true)
          return
        }
      }
      const element = document.getElementById(id);
      if (element) {
        document.getElementById(id)?.setAttribute("open", "true");
        element.scrollIntoView({ behavior: "smooth" });
      }
      return
    }
    setModal('Selecione uma proposta e canal de envio primeiro', 'Erro', false, true)
  }

  const fp: Item[] = formasPagamentos.data?.data && formasPagamentos.data.data?.message?.lista?.item?.length > 0 ? formasPagamentos.data.data?.message?.lista?.item : [];

  return (
    <div className="flex max-h-full flex-col items-center px-2">
      {
        !devedor?.cpf_cnpj && !devedorCadastro?.dadoscadastrais && devedor !== null ? <div className="w-full text-center text-primary font-bold">
          <h3>Clique duas vezes em um dos devedores ao lado para iniciar o atendimento!</h3>
        </div> : !devedorCadastro?.dadoscadastrais && devedor === null ?
          <div className="w-full text-center text-primary font-bold">
            <h3>Esse cliente nao está cadastrado em nosso banco de dados!</h3>
          </div>
          : (
            <>
              <ClienteInfo />

              {
                boleto && boleto?.url ? (<></>) : (
                  <>
                    <div className="my-4 grid w-full grid-cols-2 items-center gap-4 rounded-sm border p-4 text-sm text-gray-800 outline-none">

                      <div className="flex  flex-col">
                        <p className="font-medium my-1">Vencimento:</p>
                        <select className="w-full bg-gray-200 p-2" value={date} defaultValue={datasVencimento[datasVencimento.length - 1]} onChange={(e) => getDateVencimento(e.target.value)}>
                          {
                            datasVencimento.length > 0 ? datasVencimento.map(data => (
                              <option value={data} key={data}>{data}</option>
                            )) : <></>
                          }
                        </select>
                      </div>
                      <div className="flex flex-col ">
                        <p className=" font-medium my-1">Forma Pagamento: </p>
                        <select className="w-full bg-gray-200 p-2" value={formaPagamento} onChange={(e) => setFormaPagamnento(e.target.value)}>
                          {
                            fp && fp.length > 0 && fp.map(f => (
                              <option key={f.id} value={f.id === '1' ? 'Boleto' : f.id === '4' ? 'PIX' : 'Pgto em loja'}>{f.descricao}</option>
                            ))
                          }
                          {/* <option value="Boleto">Boleto</option>
                          <option value="PIX">PIX</option>
                          <option value="Cartao">Cartão</option> */}
                        </select>
                      </div>
                    </div>

                    <h3 className="text-md font-semibold text-gray-700" id="neg-title">
                      Proposta(s)
                    </h3>

                    <div className="my-2 w-full">
                      <ContratoData vencimento={date} formaPag={formaPagamento === 'Boleto' ? '1' : formaPagamento === 'PIX' ? '4' : '5'} />

                      {
                        !boleto.url && <CanaisEnvio formaPag={formaPagamento} />
                      }

                      <div className="flex items-center gap-4">

                        <button
                          onClick={() => goToOpeningAccordion("resumo")}
                          className="flex w-full items-center justify-center gap-2 rounded bg-primary p-2 px-4 text-white"
                        >

                          Resumo do Acordo
                        </button>
                      </div>

                    </div>

                  </>
                )
              }

              <div className="my-4 w-full">
                <ResumoAcordo formaPag={formaPagamento} vencimento={date} />
              </div>

              <GenericModal
                title={modalInfo.title}
                type={modalInfo.type}
                onClose={() => onClose()}
                show={modalInfo.isOpen && modalInfo.title === "Tabulação"}
                modalType="Tabulação"
              />

              <GenericModal
                title={modalInfo.title}
                type={modalInfo.type}
                onClose={() => onClose()}
                show={modalInfo.isOpen && modalInfo.title === "Erro Acordo"}
                modalType="Erro Acordo"
              />

              <GenericModal
                title={modalInfo.title}
                type={modalInfo.type}
                onClose={() => onClose()}
                show={modalInfo.isOpen && modalInfo.title === "RetirarTabulacao"}
                modalType="RetirarTabulacao"
              />

              <GenericModal
                title={modalInfo.title}
                type={modalInfo.type}
                onClose={() => onClose()}
                show={modalInfo.isOpen && modalInfo.title === "Proximo Atendimento"}
                modalType="Proximo Atendimento"
              />

              <GenericModal
                title={modalInfo.title}
                type={modalInfo.type}
                onClose={() => onClose()}
                show={modalInfo.isOpen}
                modalType="Cadastro Contato"
                isToSave
              />
            </>
          )
      }
    </div>
  )
}